/* Ott-common */
import { normalize } from '@dtvgo/typed-normalizr';
import { AuthType } from '@dtvgo/axios-interceptor-auth';

/* Utils */
import { VodContentEntity, PROVIDER } from '../../../utils';

/**
 * @param {import('axios').AxiosInstance} backendAxiosInstance
 */
export default function movies(backendAxiosInstance) {
  /**
   * Gets the vodCOntent from blim using the id
   * @param {string} movieId
   */
  async function getMovie(movieId) {
    const response = await backendAxiosInstance.get(`/blim/content/v1/movies/${movieId}`, {
      authType: AuthType.SESSION_TOKEN,
    });

    response.normalizedData = normalize({
      ...response.data,
      sourceProvider: PROVIDER.BLIM,
    }, VodContentEntity);

    return response;
  }

  return {
    getMovie,
  };
}
